import _ from 'lodash';
import DOMPurify from 'dompurify';

export function purify(source) {
  if (!_.isString(source) || _.isEmpty(source)) {
    return source;
  }

  var allowedTags = ['a', 'b', 'br', 'div', 'em', 'i', 'li', 'ol', 'p', 'span', 'strong', 'sub', 'sup', 'u', 'ul'];
  var allowedAttr = ['href', 'target', 'rel'];

  return DOMPurify.sanitize(source, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: allowedAttr
  });
}

export function purifyToFormatting(source) {
  if (!_.isString(source) || _.isEmpty(source)) {
    return source;
  }

  var allowedTags = ['a', 'b', 'em', 'i', 'li', 'ol', 'strong', 'sub', 'sup', 'u', 'ul'];
  var allowedAttr = ['href', 'target', 'rel'];

  return DOMPurify.sanitize(source, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: allowedAttr
  });
}
